import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import { init as initApm } from '@elastic/apm-rum';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { HeadProvider } from 'react-head';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './state/store/store';
import packageJson from '../package.json';

const root = ReactDOM.createRoot(document.getElementById('root'));
const persistor = persistStore(store);

try {
  const apm = initApm({
    // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
    serviceName: `${packageJson.name}-${window.CONFIG.ENV}`,

    // Set custom APM Server URL (default: http://localhost:8200)
    serverUrl: `${window.CONFIG.ERROR_LOGGER}`,

    // Set service version (required for sourcemap feature)
    serviceVersion: packageJson.version,
    environment: window.CONFIG.ENV,
    active: process.env.NODE_ENV === 'production',
    distributedTracingOrigins: window.location.pathname,
    logLevel: 'warn',
  });

  apm.addFilter((payload) => {
    if (payload.errors) {
      payload.errors.forEach((error) => {
        // eslint-disable-next-line no-param-reassign
        error.exception.message = error.exception.message.replace(
          'secret',
          '[REDACTED]'
        );
      });
    }
    if (payload.transactions) {
      payload.transactions.forEach((tr) => {
        tr.spans.forEach((span) => {
          if (span?.context?.http?.url) {
            const url = new URL(span.context.http.url);
            if (url.searchParams.get('token')) {
              url.searchParams.set('token', 'REDACTED');
            }
            // eslint-disable-next-line no-param-reassign
            span.context.http.url = url.toString();
          }
        });
      });
    }
    return payload;
  });
  window.apm = apm;
} catch (e) {
  // eslint-disable-next-line no-console
  console.log('Failed to start APM RUM Agent', e);
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <HeadProvider>
          <App />
        </HeadProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
